import styled from 'styled-components/macro';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { ADAPTIVE } from '@yme/tokens/screen';
import { getTextStyles } from '@yme/utils/styles';
export const DescriptionContainer = styled.div `
  background-color: ${colorCoreWhite1000};
`;
export const DescriptionStyled = styled.div `
  ${getTextStyles('Ubuntu', 400, 16, 24)}

  padding: 24px 0;

  ${ADAPTIVE.minWidth.tablet} {
    padding: 32px 0;
  }

  ${ADAPTIVE.minWidth.desktop} {
    padding: 48px 0;
  }
`;
